import { render, staticRenderFns } from "./WhatsAppIcon.vue?vue&type=template&id=03ddc68e"
import script from "./WhatsAppIcon.vue?vue&type=script&lang=js"
export * from "./WhatsAppIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports